// import tw, { styled } from "twin.macro";
import tw from "twin.macro";
import "styled-components/macro";

export const MenuButton = tw.button`
opacity-0 sticky px-3 py-8 m-2 text-6xl text-white font-poiret hover:border-transparent focus:outline-none 
`;
